import React from "react";
import inviteImage from "../../../assets/images/share1.png";
import shareIcon from "../../../assets/images/person.png";

const ShareInvite = () => {
  return (
    <div className="w-full rounded-2xl shadow-md overflow-hidden flex flex-col md:flex-row bg-white">
      {/* Left Section */}
      <div className="bg-gradient-to-b from-[#2699FF] to-[#0453b8] text-white flex flex-col justify-between md:justify-center items-center px-6 pt-6 pb-0 md:py-10 md:w-1/2">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-4">
          Share Invite Link
        </h2>

        <div className="flex justify-center w-full mt-auto">
          <img
            src={inviteImage}
            alt="Invite"
            className="w-[320px] md:w-[380px] lg:w-[420px] object-contain"
          />
        </div>
      </div>

      {/* Right Section */}
      <div className="md:w-1/2 px-6 md:px-10 py-8 md:py-10 flex flex-col justify-center">
        <h3 className="text-xl md:text-2xl font-bold text-black mb-2">Hey!</h3>

        <p className="text-base md:text-lg text-gray-800 mb-4 leading-relaxed max-w-md">
          I’m inviting you to use The Mail Whale solution, a smart, secure and a
          safe way to manage your parcels!
        </p>

        <ul className="text-sm md:text-base text-gray-800 space-y-2 mb-6 list-decimal list-inside max-w-md">
          <li>Share The Web App Link</li>
          <li>They Sign In Instantly</li>
          <li>Enjoy Our Service</li>
        </ul>

        <div className="w-full md:w-auto">
          <button
            onClick={() => {
              if (navigator.share) {
                navigator
                  .share({
                    title: "The Mail Whale",
                    text: "I’m inviting you to use The Mail Whale solution, a smart, secure and a safe way to manage your parcels!",
                    url: window.location.href,
                  })
                  .then(() => console.log("Successful share"))
                  .catch((error) => console.log("Error sharing:", error));
              } else {
                alert(
                  "Sharing is not supported on this browser. Please copy the link manually."
                );
              }
            }}
            className="w-full md:w-[240px] bg-[#2699FF] text-white text-base md:text-lg px-6 py-3 rounded-lg font-medium inline-flex items-center justify-center gap-2"
          >
            <img src={shareIcon} alt="icon" className="w-5 h-5" />
            Share Invite
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareInvite;
